module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "px-4 pb-4 pt-0",
    class: {
      'elevation-0': _vm.overview
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "month-year layout row wrap",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "py-3 pr-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.company) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.companyName))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.month) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.month))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.year) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.year))])])]), _vm._v(" "), (!_vm.overview) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.webShopResources.length > 0) ? _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.webShopResources), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              Webshop: \n              "), (resource.weShopResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.weShopResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.webShopResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.pricingPerSubscriptionModel), function(pricing, index) {
      return [_c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n                Subscription: " + _vm._s(pricing.type) + "\n              ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(subPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(subPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(subPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(subPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(" " + _vm._s(pricing.onetimeCharges || 0) + " ")])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.moonLicensePricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.moonLicensePricing), function(license, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Moon: (" + _vm._s(license.licenseId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Subscription: " + _vm._s(license.licenseType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((license.license), function(pricing, index) {
      return [_c('tr', {
        key: index
      }, [_c('td', [_vm._v("Time range (" + _vm._s(pricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(_vm.formatDate(pricing.fromDate)) + " - " + _vm._s(_vm.formatDate(pricing.toDate)))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', [_vm._v("License:")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.licenseBase.onetimeCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.licenseBase.monthlyCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n                Concurrent users (" + _vm._s(pricing.concurrentUsers.noOfConcurrentUsersCharged || 0) + " charged out of \n                " + _vm._s(pricing.concurrentUsers.noOfConcurrentUsersTotal || 0) + " total):\n              ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.concurrentUsers.onetimeCharges))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.concurrentUsers.monthlyCharges))])])]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(" " + _vm._s(license.totalCharges) + " ")])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.webSpacePricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.webSpacePricing), function(webspace, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Webspace: (" + _vm._s(webspace.webSpaceId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((webspace.pricingPerWebSpaceType), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlyWebSpaceTypePricing), function(webPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(webPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(webPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(webPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.totalMonthlyCharges || 0))])])]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(webspace.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.domainPricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.domainPricing), function(domain, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Domain: "), _c('strong', [_vm._v(_vm._s(domain.domainName))]), _vm._v(" (" + _vm._s(domain.domainId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((domain.pricingPerDomainType), function(pricing) {
      return [_vm._l((pricing.monthlyDomainTypePricing), function(monthly, index) {
        return [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthly.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthly.fromDate)) + " - " + _vm._s(_vm.formatDate(monthly.toDate)))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])])]
      })]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(domain.totalChargesBeforeDiscount))])]), _vm._v(" "), (domain.discount) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Discount (" + _vm._s(domain.discountedDays) + " days)")]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v("-" + _vm._s(domain.discount))])]) : _vm._e(), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(domain.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.individualApp.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.individualApp), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              App: \n              "), (resource.appResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.appResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.appResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Type: " + _vm._s(resource.appResourceType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.appResourcePricingPerSubscriptionModel), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthlyPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthlyPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthlyPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(monthlyPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.restaurantApp.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.restaurantApp), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              App: \n              "), (resource.appResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.appResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.appResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Type: " + _vm._s(resource.appResourceType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.appResourcePricingPerSubscriptionModel), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthlyPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthlyPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthlyPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(monthlyPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pt-2"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Total:")])]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_c('strong', [_vm._v(_vm._s(_vm.allDetails.totalAmount) + " " + _vm._s(_vm.allDetails.currency === 'GBP' ? '£' : '€'))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d22135f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/InvoiceDetails.vue
// module id = 586
// module chunks = 2